import { create } from "zustand";
import type { TradeItem } from "modules/tradeLists/model/tradeList";
import { tradeItemTransitionKey } from "modules/tradeLists/utils/tradeItemTransitionKey";

export function tradeItemPendingAddKey(item: TradeItem): string {
  return tradeItemTransitionKey(item);
}

interface TradeItemPendingState {
  pendingAddKeys: Set<string>;
  beginAdd: (key: string) => void;
  endAdd: (key: string) => void;
}

/** Pending creates live outside row data so a background refetch cannot unlock stale IDs. */
export const useTradeItemPendingStore = create<TradeItemPendingState>(
  (set) => ({
    pendingAddKeys: new Set(),
    beginAdd: (key) =>
      set((state) => {
        if (state.pendingAddKeys.has(key)) return state;
        const pendingAddKeys = new Set(state.pendingAddKeys);
        pendingAddKeys.add(key);
        return { pendingAddKeys };
      }),
    endAdd: (key) =>
      set((state) => {
        if (!state.pendingAddKeys.has(key)) return state;
        const pendingAddKeys = new Set(state.pendingAddKeys);
        pendingAddKeys.delete(key);
        return { pendingAddKeys };
      }),
  })
);
